<template>
  <div class="nebMetric">
    <div class="nebMetric-value">
      <slot name="value">
        <p class="nebMetric-value-text">{{ value }}</p>
      </slot>
    </div>

    <div class="nebMetric-title">
      <slot name="title">
        <p class="nebMetric-title-text">{{ title }}</p>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NebMetric',

  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
@import '../../style.scss';

.nebMetric {
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  p {
    margin: 0;
  }

  &-value {
    padding-bottom: 5px;

    &-text {
      font-family: $defaultFont;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: $slate-grey;
    }
  }

  &-title {
    &-text {
      font-family: $defaultFont;
      font-size: 11px;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: $slate-grey;
    }
  }
}
</style>
